import React from 'react';
import { Row, Col } from 'antd';
import BaseWeeklyPage from '../../common/baseWeeklyPage';
import Header from '../../common/weeklyHeader';
import MembersWidget from './members.js';
import PointsEarnedWidget from './pointsEarned.js';
import PrayingWidget from './praying.js';
import FastingWidget from './fasting.js';
import OvercomingWidget from './overcoming.js';
import GuestCardActivitiesWidget from './guestCardActivities.js';
import GoalsAndAveragesWidget from './goalsAndAverages.js';
import GroupComparisonWidget from './groupComparison.js';
import WidgetContainer from '../../common/widgetContainer';

export default class WeeklyPage extends BaseWeeklyPage {
  get widgetParams() {
    return {
      churchId: this.props.selectedChurch.id,
      timezone: this.props.selectedChurch.timezone,
      periodStartTime: this.periodStartDate.unix(),
      periodEndTime: this.periodEndDate.unix()
    }
  }

  get header() {
    return (
      <Row className="statistics-page-header-row">
        <Col size={24} className="statistics-page-header-with-filter">
          <div className="statistics-page-header">
            <Header churchId={this.props.selectedChurch.id}
                    periodStartTime={this.periodStartDate.unix()}
                    periodEndTime={this.periodEndDate.unix()}/>
          </div>
          { this.weekSelector }
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <WidgetContainer header={this.header}>
        <MembersWidget {...this.widgetParams} position={{ xl: 0, lg: 0, md: 0 }} />
        <PointsEarnedWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <OvercomingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <GuestCardActivitiesWidget {...this.widgetParams} position={{ xl: 0, lg: 1, md: 0 }} />
        <GoalsAndAveragesWidget {...this.widgetParams} position={{ xl: 1, lg: 1, md: 0 }} />
        <FastingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <PrayingWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <GroupComparisonWidget {...this.widgetParams} position={{ xl: 2, lg: 1, md: 0 }} />
      </WidgetContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/weekly/weekly.js